import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CtaBand = () => {
  return (
    <section className="relative overflow-hidden bg-navy text-white" data-testid="final-cta">
      <div className="absolute inset-0 grid-bg opacity-40" aria-hidden />
      <div className="absolute -top-24 left-1/3 w-[420px] h-[420px] rounded-full bg-aqua/15 blur-[100px]" aria-hidden />
      <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-12 py-20 lg:py-28">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.22em] text-aqua font-semibold">Ready when you are</p>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
            Ready to build <br className="hidden md:block" />
            your <span className="text-aqua">India team?</span>
          </h2>
          <p className="mt-6 text-lg text-white/75 leading-relaxed">
            Speak to Bright EOR about hiring, onboarding or managing India-based remote staff without setting up an Indian company.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link
              to="/contact"
              data-testid="cta-band-primary"
              className="group inline-flex items-center gap-2 rounded-full bg-aqua px-6 py-3 text-[15px] font-medium text-navy hover:shadow-aqua-glow transition-all"
            >
              Book a Consultation
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
            <Link
              to="/contact"
              data-testid="cta-band-secondary"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-[15px] font-medium text-white hover:bg-white/5 transition-colors"
            >
              Request a Cost Breakdown
            </Link>
          </div>
          <p className="mt-8 text-sm text-white/55">UK-led support. India-based talent. One managed process.</p>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
